import { Form, Input, InputNumber } from "antd";
import { FormItemProps, Rule } from "antd/es/form";
import { FormLabelAlign } from "antd/es/form/interface";
import React from "react";
import { isMobile } from "react-device-detect";
import "./index.scss";
const { TextArea } = Input;

interface IProps {
  name: string;
  labelAlign?: FormLabelAlign;
  label?: string;
  placeholder?: string;
  rules?: Rule[];
  cssWrap?: React.CSSProperties;
  cssInput?: React.CSSProperties;
  iconLeft?: React.ReactNode;
  cssIconLeft?: React.CSSProperties;
  cssIconRight?: React.CSSProperties;
  labelEmpty?: boolean;
  type?: string;
  styleLabel?: React.CSSProperties;
  areaRows?: number;
  styleTextarea?: React.CSSProperties;
  formatter?: (v: string) => string;
  iconRight?: React.ReactNode;
  formItemProps?: FormItemProps;
  maxLength?: number;
  min?: number;
  disabled?: boolean;
  customOnchange?: (v: any) => void;
}

function NafutelInputFormComponent({
  name,
  labelAlign,
  label,
  placeholder,
  rules,
  cssWrap,
  cssInput,
  iconLeft,
  cssIconLeft,
  labelEmpty = false,
  type = "text",
  styleLabel,
  areaRows = 4,
  styleTextarea,
  formatter,
  iconRight,
  cssIconRight,
  formItemProps,
  maxLength,
  min,
  disabled = false,
  customOnchange,
}: IProps) {
  const isRequired = rules ? rules.some((ele: any) => !!ele.required) : false;

  const renderElement = () => {
    if (type === "textarea") {
      return (
        <TextArea
          autoComplete="off"
          className="textarea-nafutel"
          rows={areaRows}
          placeholder={placeholder}
          style={{ ...styleTextarea }}
          disabled={disabled}
          onChange={customOnchange}
        />
      );
    }
    if (type === "password") {
      return (
        <Input.Password
          autoComplete="off"
          className="input-nafutel"
          placeholder={placeholder}
          style={{
            paddingLeft: iconLeft ? 30 : 10,
            ...cssInput,
          }}
          disabled={disabled}
          onChange={customOnchange}
        />
      );
    }
    if (type === "number") {
      return (
        <InputNumber
          autoComplete="off"
          className="input-nafutel-number"
          placeholder={placeholder}
          formatter={
            formatter
              ? (value) => formatter(value)
              : (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value: any) => value!.replace(/\$\s?|(,*)/g, "")}
          prefix={null}
          style={{ ...cssInput }}
          maxLength={maxLength}
          min={min}
          disabled={disabled}
          onChange={customOnchange}
        />
      );
    }
    if (type === "number-default") {
      return (
        <InputNumber
          autoComplete="off"
          className="input-nafutel-number"
          placeholder={placeholder}
          prefix={null}
          style={{ ...cssInput }}
          maxLength={maxLength}
          min={min}
          disabled={disabled}
          onChange={customOnchange}
        />
      );
    }
    return (
      <Input
        autoComplete="nope"
        className="input-nafutel"
        placeholder={placeholder}
        style={{ paddingLeft: iconLeft ? 30 : 10, ...cssInput }}
        maxLength={maxLength}
        disabled={disabled}
        onChange={customOnchange}
      />
    );
  };

  return (
    <div className="wrap-input-style " style={{ ...cssWrap }}>
      {iconLeft && (
        <div className="icon-input-nafutel" style={{ ...cssIconLeft }}>
          {iconLeft}
        </div>
      )}
      <Form.Item
        colon={false}
        labelAlign={labelAlign}
        label={
          label ? (
            <div className="label-input-nafutel" style={{ ...styleLabel }}>
              {label}
              {isRequired && <span className="required-form-red" />}
            </div>
          ) : labelEmpty ? (
            <React.Fragment />
          ) : null
        }
        name={name}
        rules={rules}
        style={{ marginBottom: isMobile ? 20 : 24 }}
        validateTrigger={["onChange", "onBlur"]}
        {...formItemProps}
      >
        {renderElement()}
      </Form.Item>

      {Boolean(iconRight) && (
        <div className="icon-right-input" style={{ ...cssIconRight }}>
          {iconRight}
        </div>
      )}
    </div>
  );
}

export default NafutelInputFormComponent;
